export default __webpack_public_path__ + "static/media/education.2c94c976.png";